/**
 * TPO/TOR renewals pilot. Visible only on the CGICHEHA underwriting account
 * until the feature is opened to agents.
 */

const PILOT_USERNAME = 'cgicheha';
const PILOT_EMAIL = 'cgicheha@monarchinsurance.co.ke';

function norm(value) {
  return String(value || '').trim().toLowerCase();
}

export function canSeeRenewals(user) {
  if (!user) return false;
  return norm(user.username) === PILOT_USERNAME || norm(user.email) === PILOT_EMAIL;
}
